import styled, { css, keyframes } from 'styled-components';
var DURATION = '0.4s';
var DURATION_ERROR = '1s';
export var Fade = styled.span.withConfig({
  displayName: "animation__Fade",
  componentId: "sc-1q9p07m-0"
})(["line-height:0;transition:", ";", ""], DURATION, function (_ref) {
  var state = _ref.state;

  switch (state) {
    case 'entering':
    case 'exited':
      return css(["opacity:0;"]);

    case 'entered':
    case 'exiting':
      return css(["opacity:1;"]);
  }
});
export var RevealBottomIn = styled.span.withConfig({
  displayName: "animation__RevealBottomIn",
  componentId: "sc-1q9p07m-1"
})(["line-height:0;transition:", ";", ""], DURATION, function (_ref2) {
  var state = _ref2.state;

  switch (state) {
    case 'entering':
      return css(["animation:", " ", ";"], fade_in, DURATION);

    case 'entered':
      return css(["opacity:1;"]);

    case 'exiting':
      return css(["animation:", " ", ";"], fade_out, DURATION);

    case 'exited':
      return css(["opacity:0;"]);
  }
});
export var RotateIn = styled.span.withConfig({
  displayName: "animation__RotateIn",
  componentId: "sc-1q9p07m-2"
})(["line-height:0;transition:", ";", ""], DURATION_ERROR, function (_ref3) {
  var state = _ref3.state;

  switch (state) {
    case 'entering':
      return css(["animation:", " ", ";"], rotate_in, DURATION);

    case 'entered':
      return css(["opacity:1;"]);

    case 'exiting':
      return css(["animation:", " ", ";"], fade_out, DURATION);

    case 'exited':
      return css(["opacity:0;"]);
  }
});
var fade_in = keyframes(["0%{opacity:0;transform:translate(0,10px);}80%{transform:translate(0,-2px);}100%{opacity:1;transform:translate(0,0);}"]);
var rotate_in = keyframes(["0%{opacity:0;transform:rotate(-90deg);}100%{opacity:1;transform:rotate(0);}"]);
var fade_out = keyframes(["0%{opacity:1;}100%{opacity:0;}"]);